import { LanguageChoice } from "@/components/language-choice";
import { CompanySwitcher } from "@/components/company-switcher";
import { Link, usePage } from "@inertiajs/react";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { pathOnly } from "@/lib/navigation";

export default function BillingRecoveryLayout({ children }: PropsWithChildren) {
  const { t } = useTranslation();
  const { url, props } = usePage();
  const admin = props.auth.user?.role === "admin";
  return (
    <div className="flex min-h-svh w-full min-w-0 flex-col gap-section p-page">
      <nav
        className="flex flex-wrap items-center gap-2"
        aria-label={t("navigation.recovery")}
      >
        <CompanySwitcher />
        <LanguageChoice />
        {admin && (
          <>
            <Button
              variant="outline"
              nativeButton={false}
              render={<Link href="/user/resource_selection" />}
            >
              {t("resources.title")}
            </Button>
            <Button
              variant="outline"
              nativeButton={false}
              render={<Link href="/user/billing" />}
            >
              {t("navigation.subscription")}
            </Button>
          </>
        )}
        <Button
          variant="ghost"
          nativeButton={false}
          render={<Link href="/logout" method="delete" as="button" />}
        >
          {t("recovery.logout")}
        </Button>
        {admin && pathOnly(url) !== "/user/account_closure" && (
          <div
            role="group"
            aria-label={t("navigation.danger")}
            className="border-l pl-4"
          >
            <Link
              className="inline-flex min-h-11 items-center rounded-sm text-sm text-destructive underline focus-visible:ring-2"
              href="/user/account_closure"
            >
              {t("recovery.delete_account")}
            </Link>
          </div>
        )}
      </nav>
      <main id="main-content" tabIndex={-1} className="min-w-0">
        {children}
      </main>
    </div>
  );
}
